import BaseService from '../baseServices';
import REST from '../../configs/rest';

function getSPK({ orderId, productSoldId }) {
  return BaseService.get(REST.SPK(orderId, productSoldId));
}

function putSPK({ orderId, productSoldId, body }) {
  return BaseService.put(REST.SPK(orderId, productSoldId), body);
}

function postSPK({ orderId, productSoldId, body }) {
  return BaseService.post(REST.SPK(orderId, productSoldId), body);
}

function postSPKImages({ orderId, productSoldId, body }) {
  return BaseService.post(REST.SPK_IMAGE(orderId, productSoldId), body);
}

function getSPKImages({ orderId, productSoldId }) {
  return BaseService.get(REST.SPK_IMAGE(orderId, productSoldId));
}

function deleteSPKImages({ orderId, productSoldId }) {
  return BaseService.delete(REST.SPK_IMAGE(orderId, productSoldId));
}

export default {
  getSPK,
  putSPK,
  postSPK,
  getSPKImages,
  deleteSPKImages,
  postSPKImages,
};
